import { Component, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { ToastComponent } from '../../shared/toast/toast.component';
import { setClassInvalid } from '../../shared/functions';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-reset-password-form',
  templateUrl: './reset-password-form.component.html',
  standalone: false
})
export class ResetPasswordFormComponent {
  private userService = inject(UserService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private formBuilder = inject(UntypedFormBuilder);
  toast = inject(ToastComponent);


  resetPasswordForm = this.createResetPasswordForm();
  inputPasswordType = 'password';
  setClassInvalid = setClassInvalid;

  createResetPasswordForm(): UntypedFormGroup {
    return this.formBuilder.group({
      password: ['', Validators.compose([
        Validators.required,
        Validators.minLength(8)
      ])]
    });
  }

  toggleInputPasswordType(): void {
    this.inputPasswordType = this.inputPasswordType === 'password' ? 'text' : 'password';
  }

  resetPassword(): void {
    const token = this.route.snapshot.paramMap.get('token');
    const password = this.resetPasswordForm.get('password').value;
    this.userService.resetPassword({ token, password })
      .subscribe({
        next: res => {
          this.toast.setMessage('Password changed successfully.', 'success');
          this.router.navigate(['/login']);
        },
        error: err => this.toast.setMessage(err.error.message, 'danger')
      });
  }

}
